import { useRef as x, useState as q, useMemo as m, useEffect as w, useCallback as o } from "react";
import { m as F } from "../../../libServer-iuAIJuwv.js";
const y = 111320;
function K({
  initialSingleMarker: l,
  randomPosition: f = !1,
  id: I = "1",
  onMoveEnd: u,
  onDragEnd: n,
  onResize: h,
  ref: c,
  debounceEventsTime: a = 300
}) {
  const s = x(null), [M, A] = q(!1), p = x(null), L = m(() => {
    if (!f) return null;
    const t = I.toString();
    let r = 0;
    for (let e = 0; e < t.length; e++)
      r = (r << 5) - r + t.charCodeAt(e), r = r & r;
    return () => {
      const e = Math.sin(r++) * 1e4;
      return e - Math.floor(e);
    };
  }, [f, I]), B = m(() => {
    if (!l) return null;
    if (!f || !L) return l;
    const t = { ...l }, r = L, e = r() * 2 * Math.PI, g = r() * 500, j = g / y * Math.cos(e), k = g / (y * Math.cos(t.latitude * Math.PI / 180)) * Math.sin(e);
    return t.latitude += j, t.longitude += k, t;
  }, [l, f, L]);
  w(() => {
    c && s.current && (typeof c == "function" ? c(s.current) : c.current = s.current);
  }, [c, M]);
  const d = m(() => a <= 0 || !u ? null : F(() => {
    if (p.current) {
      const { event: r, bounds: e } = p.current;
      u(r, e);
    }
  }, a), [a, u]), C = o(
    (t) => {
      var r, e;
      a > 0 && d ? (p.current = { event: t, bounds: (r = s.current) == null ? void 0 : r.getBounds() }, d()) : u == null || u(t, (e = s.current) == null ? void 0 : e.getBounds());
    },
    [u, a, d]
  ), S = o(
    (t) => {
      n == null || n(t);
    },
    [n]
  ), G = o(
    (t) => {
      h == null || h(t);
    },
    [h]
  ), O = o(() => {
    A(!0);
  }, []);
  return {
    mapRef: s,
    mapLoaded: M,
    singleMarker: B,
    handleMoveEnd: C,
    handleDragEnd: S,
    handleResize: G,
    handleMapLoad: O
  };
}
export {
  y as OneDegreeInMeters,
  K as useMap
};
